module.exports = __webpack_public_path__ + "static/media/research photos.94c01fc8.png";